/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Comp_CreateInputs */

const en_nav_comp_create = /** @type {(inputs: Nav_Comp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Comp`)
};

const es_nav_comp_create = /** @type {(inputs: Nav_Comp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo Comp`)
};

/**
* | output |
* | --- |
* | "New Comp" |
*
* @param {Nav_Comp_CreateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
const nav_comp_create = /** @type {((inputs?: Nav_Comp_CreateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Comp_CreateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_comp_create(inputs)
	return en_nav_comp_create(inputs)
});
export { nav_comp_create as "nav.comp.create" }